import { ProductTypeEnum as e } from "../../enums/product-type-enum.mjs";
import { StoreItemEnum as t } from "../../../../enums/store-item-enum.mjs";
const u = {
  type: t.product,
  productType: e.eCourse,
  title: "My 12-week Program!",
  subTitle: "A 2-line course summary to close the sale. What will they learn?",
  buttonTitle: "GET MY COURSE",
  thumbnail: null,
  checkoutPage: {}
};
export {
  u as defaultECourseValues
};
